<template>
  <div class='wrapper'>
    <div class='body'>
      <img src="../../assets/icon/vote_success.png" class='ic-cup' />
      <div class='title'>投票成功</div>
      <div class='desc' v-if=" hide_result!= 2 ">分享给好友拉票吧~</div>
      <div class='desc' v-else>投票截止后会给您发送最终投票结果</div>
      <div class='btn-box' v-if="no_forward==1">
        <button class='button'>返回上一页</button>
      </div>
      <div class='btn-box' v-else>
        <button class='button' @click="isViewShare = true">分享投票</button>
        <div class='space' />
        <button class='button' v-if="show==1">随便逛逛</button>
        <div class='space' />
        <button class='button' @click="back">返回上一页</button>
      </div>
    </div>

    <!--分享好友引导-->
    <section class="share-friend" v-if="isViewShare" @click="isViewShare = false">
      <div class="arrow">
        <img src="../../assets/icon/ic_mask_arrow.png" />
      </div>
      <div class="share-desc">点击右上角“...”</div>
      <div class="share-desc">选择“发送给朋友”或者“分享到朋友圈”</div>
      <div class="share-desc">即可完成分享</div>
    </section>
  </div>

</template>

<script>
import router from '@/router/index'
import http from '@/utils/request';
import api from '@/utils/api'
import { getToken, formatDateTime } from '@/utils/common'
import { constants } from 'fs';

export default {
  data() {
    return {
      hide_result: 0,
      no_forward: 0,
      show: 0,
      isViewShare: false,
      defaultBanner: require("../../assets/icon/default_banner.png")
    }
  },
  mounted() {
    this.vid = this.$route.query.vid;
    this.hide_result = this.$route.query.hide_result;
    this.no_forward = this.$route.query.no_forward;
    this.initWxShare();
  },
  methods: {
    back() {
      this.$router.go(-1);//返回上一层
    },
    initWxShare() {
      var self = this;
      var shareInfo = {
        title: '投票成功',
        url: 'http://m.huodongtou.cn/?vid=' + this.vid,
        imgUrl: this.defaultBanner
      }
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: shareInfo.title, // 分享标题
          desc: '快来参加投票吧！', // 分享描述
          link: shareInfo.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareInfo.imgUrl, // 分享图标
        })
        wx.updateTimelineShareData({
          title: shareInfo.title, // 分享标题
          link: shareInfo.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareInfo.imgUrl, // 分享图标
        })
      });
    },
  }

}

</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}
.body {
  background: #fff;
  margin-bottom: rem(10);
  padding: rem(55) 0 0;
}

.ic-cup {
  display: block;
  width: rem(68);
  height: rem(50);
  margin: 0 auto rem(15);
}

.title {
  font-size: rem(18);
  color: #333;
  text-align: center;
}

.desc {
  font-size: rem(14);
  color: #999;
  padding: rem(10) rem(15) rem(15);
  text-align: center;
}

.btn-box {
  display: flex;
  padding: rem(15) rem(15) rem(5);
}
.button {
  width: rem(345);
  height: rem(43);
  background-color: #00a8f3;
  color: #fff;
  font-size: rem(15);
  margin-bottom: rem(10);
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-left: rem(7);
  padding-right: rem(7);
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;
  line-height: 2.85;
  border-radius: rem(3);
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
}
.btn-box .button {
  font-size: rem(14);
  flex: 1;
  height: rem(38);
  line-height: rem(38);
}

.btn-box .space {
  width: rem(15);
}
.share-friend {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10001;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  .arrow {
    width: 100%;
    margin-bottom: rem(100);
    text-align: end;
    img {
      margin-top: 5px;
      margin-right: rem(15);
      width: rem(58);
    }
  }
  .share-desc {
    text-align: center;
    font-size: rem(20);
    color: #22bbff;
    margin-top: rem(5);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/success/success.vue